import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Inbox, MessageSquare, Lock, BookOpen, ChevronLeft, ChevronRight, X } from 'lucide-react';
import { getBrand } from '../utils/brand';

// Primer ingreso en la instancia de un CLIENTE. No es el onboarding de RRHH (ese pide DNI y
// firma de documentos, y es para empleados nuestros): acá el objetivo es que alguien que nunca
// vio la plataforma pueda tomar su primer pedido sin preguntarle nada a nadie.
// Se muestra una sola vez por usuario. Saltable en cualquier paso.
const CLAVE = 'tenant_welcome_v1__';

export function debeVerBienvenida(userId) {
  if (getBrand()?.esAyudaTecno !== false) return false;   // sólo instancias de cliente
  if (!userId) return false;
  try { return !localStorage.getItem(CLAVE + userId); } catch { return false; }
}

export default function TenantWelcomeWizard({ userId, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [i, setI] = useState(0);
  const marca = getBrand();

  const cerrar = (ir) => {
    try { localStorage.setItem(CLAVE + userId, Date.now()); } catch { /* modo privado */ }
    onClose?.();
    if (ir) navigate(ir);
  };

  const pasos = [
    { icon: Inbox,         titulo: t('tenantWelcome.s1.title'), texto: t('tenantWelcome.s1.body') },
    { icon: MessageSquare, titulo: t('tenantWelcome.s2.title'), texto: t('tenantWelcome.s2.body') },
    { icon: Lock,          titulo: t('tenantWelcome.s3.title'), texto: t('tenantWelcome.s3.body') },
    { icon: BookOpen,      titulo: t('tenantWelcome.s4.title'), texto: t('tenantWelcome.s4.body') },
  ];
  const p = pasos[i];
  const Icono = p.icon;
  const ultimo = i === pasos.length - 1;

  const modal = (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) cerrar(); }}
      style={{ position: 'fixed', inset: 0, zIndex: 1200, display: 'flex', alignItems: 'center',
               justifyContent: 'center', background: 'rgba(0,0,0,0.55)', padding: 16 }}
    >
      <div onMouseDown={(e) => e.stopPropagation()} className="card"
           style={{ margin: 0, maxWidth: 520, width: '100%', maxHeight: '88vh', overflowY: 'auto', padding: 0 }}>

        <div style={{ background: marca.primary || 'var(--c-brand)', padding: '18px 22px',
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>
            {t('tenantWelcome.header', { marca: marca.name })}
          </div>
          <button className="btn btn-ghost btn-icon" onClick={() => cerrar()}
                  aria-label={t('common.close')} style={{ color: '#fff' }}>
            <X size={16} />
          </button>
        </div>

        <div style={{ padding: 24, textAlign: 'center' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 56, height: 56, borderRadius: 16, background: 'var(--c-surface-2)', marginBottom: 14 }}>
            <Icono size={26} style={{ color: marca.primary || 'var(--c-brand)' }} />
          </div>
          <h2 style={{ margin: '0 0 10px', fontSize: 19, color: 'var(--c-text)' }}>{p.titulo}</h2>
          <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.6, color: 'var(--c-text-muted)' }}>{p.texto}</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, paddingBottom: 14 }}>
          {pasos.map((_, n) => (
            <span key={n} style={{ width: n === i ? 18 : 6, height: 6, borderRadius: 3,
                                   background: n === i ? (marca.primary || 'var(--c-brand)') : 'var(--c-border)',
                                   transition: 'width .2s' }} />
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8, padding: '0 22px 22px', alignItems: 'center' }}>
          <button className="btn btn-ghost btn-sm" onClick={() => cerrar()}>{t('tenantWelcome.skip')}</button>
          <div style={{ flex: 1 }} />
          {i > 0 && (
            <button className="btn btn-secondary btn-sm" onClick={() => setI(i - 1)}>
              <ChevronLeft size={14} /> {t('common.back')}
            </button>
          )}
          {!ultimo ? (
            <button className="btn btn-primary btn-sm" onClick={() => setI(i + 1)}>
              {t('common.next')} <ChevronRight size={14} />
            </button>
          ) : (
            <button className="btn btn-primary btn-sm" onClick={() => cerrar('/kb')}>
              {t('tenantWelcome.cta')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
  return ReactDOM.createPortal(modal, document.body);
}
